<template>
  <div class="recharge-edit">
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="PC端背景设置">
      <menu-background-image :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="移动端背景设置">
      <menu-background-image :target="model.mobileBackground" target-key="mobileBackground" />
    </menu-item>
    <menu-item label="布局">
      <menu-switch v-model="model.titleVisible" label="标题" />
      <menu-switch v-model="model.handleButtonVisible" label="提示按钮">
        <template v-if="model.handleButtonVisible" >
          <base-input v-model="model.handleButtonText" class="w-full mt-2" size="small" placeholder="按钮名称" />
          <menu-background-image :target="model.handleButtonIcon" image-size-key=" " class="mt-2 w-full" />
          <nav-edit :site="site" :model="model" :target="model.pilot" class="mt-2" />
        </template>
      </menu-switch>
    </menu-item>
    <menu-item label="充值背景圆角">
      <menu-slider v-model="model.radius" />
    </menu-item>
    <menu-item label="充值背景阴影">
      <menu-slider v-model="model.boxShadow" />
    </menu-item>
    <menu-item label="面额文字色">
      <menu-fill :target="model.faceColor" solid-color target-key="faceColor" />
    </menu-item>
    <menu-item label="名称文字色">
      <menu-fill :target="model.nameColor" solid-color target-key="nameColor" />
    </menu-item>
    <menu-item label="按钮填充色">
      <menu-fill :target="model.buttonBackground" target-key="buttonBackground" />
    </menu-item>
    <menu-item label="按钮文字色">
      <menu-fill :target="model.buttonColor" solid-color target-key="buttonColor" />
    </menu-item>
    <menu-item label="充值板块">
      <div class="recharge-edit__list">
        <div v-for="(item, index) in model.list" :key="`${index}-${item.faceId}`" class="item rounded-sm">
          <div class="flex items-center justify-between w-full mb-2">
            <div class="text-12">面额板块{{ index + 1 }}</div>
            <i class="el-icon-delete cursor-pointer hover:text-danger" @click="handleRemove(index)" />
          </div>
          <im-select v-model="item.faceId" size="small" :options="$store.state.project.newRechargeValueList" value-key="id" clearable />
          <menu-item label="充值背景" size-tip="建议比例(4:3)">
            <menu-fill :target="item.background" />
            <menu-background-image :target="item.background" class="mt-2" />
          </menu-item>
        </div>
      </div>
    </menu-item>
    <menu-button class="mt-4" icon="add" @click.native="handleAddItem">添加充值板块</menu-button>
    <menu-button class="mt-4" icon="add" :help-text="$t('menu.copyBlock')" @click.native.stop="handleClone">{{ $t('menu.createCopy') }}</menu-button>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import MenuItem from "~/components/menu/menuItem.vue";
import MenuFill from "~/components/menu/menuFill.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";
import MenuSwitch from "~/components/menu/menuSwitch.vue";
import MenuSlider from "~/components/menu/menuSlider.vue";
import MenuButton from "~/components/menu/menuButton.vue";
import ImSelect from "~/components/common/ImSelect.vue";
import BaseInput from '~/components/base/baseInput.vue'
import NavEdit from '~/site/components/navEdit.vue'

export default {
  name: 'RechargeWidgetEdit',
  components: {
    NavEdit,
    BaseInput,
    ImSelect,
    MenuButton,
    MenuSlider,
    MenuSwitch,
    MenuBackgroundImage,
    MenuFill,
    MenuItem
  },
  props: {
    site: Object,
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      mobileColumnOptions: [
        {
          label: '2列',
          value: 2
        },
        {
          label: '3列',
          value: 3
        }
      ],
      columnOptions: [
        {
          label: '4列',
          value: 4
        },
        {
          label: '5列',
          value: 5
        },
        {
          label: '6列',
          value: 6
        }
      ]
    }
  },
  methods: {
    handleClone() {
      //
    },
    handleAddItem() {
      this.model.__addItem()
    },
    handleRemove(index) {
      this.model.list.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="less">
.recharge-edit {
  &__list {
    .item {
      background-color: @fill-color-2;
      padding: 12px 10px 12px 8px;
      margin-bottom: 16px;
    }
  }
}
</style>
